import React from "react";
import { Container, Grid, Text } from "@mantine/core";

import { CustomPillTabs, CustomUnderlineTabs } from "@components/custom";

export function TabsStylesheet() {
  return (
    <Grid mb="xl">
      <Grid.Col span={{ base: 12, lg: 6 }}>
        <Container mb="md">
          <CustomPillTabs
            size="xs"
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomPillTabs
            size="sm"
            variant="sky"
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomPillTabs
            size="md"
            variant="carrot"
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomPillTabs
            size="lg"
            variant="flamingo"
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomPillTabs
            size="xl"
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
      </Grid.Col>
      <Grid.Col span={{ base: 12, lg: 6 }}>
        <Container mb="md">
          <CustomUnderlineTabs
            size="xs"
            childWithDot={2}
            values={["Tab 1", "Tab 2", "Tab 3"]}
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomUnderlineTabs
            size="sm"
            variant="sky"
            childWithDot={2}
            values={["Tab 1", "Tab 2", "Tab 3"]}
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomUnderlineTabs
            size="md"
            childWithDot={2}
            variant="carrot"
            values={["Tab 1", "Tab 2", "Tab 3"]}
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomUnderlineTabs
            size="lg"
            childWithDot={2}
            variant="flamingo"
            values={["Tab 1", "Tab 2", "Tab 3"]}
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
        <Container mb="md">
          <CustomUnderlineTabs
            size="xl"
            childWithDot={2}
            values={["Tab 1", "Tab 2", "Tab 3"]}
            tabs={["Tab 1", "Tab 2", "Tab 3"]}
            panels={[
              <Text>Content A</Text>,
              <Text>Content B</Text>,
              <Text>Content C</Text>,
            ]}
          />
        </Container>
      </Grid.Col>
    </Grid>
  );
}
